import { useEffect, useState } from 'react'

import { useUnit } from 'effector-react'

import CloseIcon from '@/assets/icons/icon-close.svg'
import { Button } from '@/components/ui/button'
import { setMessageIdToFetch } from '@/models/chattingUI/messages/messages.ts'
import {
  $searchResultIndex,
  $searchedMessageIds,
  searchTextFx,
  setSearch,
} from '@/models/chattingUI/messages/search.ts'

import { SearchField } from '../components/search-field'

interface Props {
  isVisible: boolean
  onHide: () => void
}

export const ChatMessageSearch = ({ isVisible, onHide }: Props) => {
  const isSearching = useUnit(searchTextFx.pending)
  const searchedMessageIds = useUnit($searchedMessageIds)
  const searchResultIndex = useUnit($searchResultIndex)
  const [value, setValue] = useState('')

  useEffect(() => {
    if (!isVisible) {
      setValue('')
    }
  }, [isVisible])

  const handleClickClose = () => {
    setValue('')
    onHide()
  }

  const handleSearchChange = (value: string) => {
    setValue(value)
    setSearch(value)
  }

  return isVisible ? (
    <div className="absolute left-6 right-6 top-2 z-20 flex items-stretch gap-2">
      <SearchField
        isSearching={isSearching}
        results={searchedMessageIds}
        handleSearchChange={handleSearchChange}
        value={value}
        shownResultIndex={searchResultIndex}
        onNext={(index) => setMessageIdToFetch({ messageIdToFetch: index })}
        onPrev={(index) => setMessageIdToFetch({ messageIdToFetch: index })}
      />
      <Button
        variant="outline"
        onClick={handleClickClose}
        className="hover:border-primary-500 hover:bg-card dark:border-secondary-400"
      >
        <CloseIcon />
      </Button>
    </div>
  ) : null
}
